import * as Autocomplete from './components/Autocomplete.css';

export const defaultTheme = {
	Autocomplete
};

export default defaultTheme;
